import PropTypes from 'prop-types'
import React from 'react'
import {
  Checkbox,
  FlatButton,
  Dialog,
} from 'material-ui'

import moment from 'moment-timezone'
import BookingDropdown from './BookingDropdown'
import ManualTimeFields from './ManualTimeFields'
import FifteenTimeFields from './FifteenTimeFields'
import styles from './styles/bookingPopover.css'
import manualTimeCheckboxStyles from './styles/manualTimeCheckbox'

const resolvedAutoBooking = ({ automation, status }) => {
  return automation && status === 'booked'
}

class RegularBookingPopover extends React.Component {
  constructor() {
    super()
    this.state = {
      startTimes: [],
      endTimes: [],
      manualTimes: false,
    }
    this.fifteenIntervals = ['00', '15', '30', '45']
  }

  componentDidMount() {
    this.renderStartTimes()
    this.renderEndTimes()
    if (!this.props.isNew && !this.timesAreFifteenIntervals()) {
      this.setState({
        manualTimes: true
      })
    }
  }

  componentDidUpdate(prevProps) {
    const { start, end } = this.props
    if (prevProps.start !== start || prevProps.end !== end) {
      this.renderEndTimes()
    }
  }

  timesAreFifteenIntervals = () => {
    const { start, end } = this.props
    const startMinutes = start.split(':')[1]
    const endMinutes = end.split(':')[1]
    return this.fifteenIntervals.includes(startMinutes) && this.fifteenIntervals.includes(endMinutes)
  }

  filterTimesFifteen = timeList => (
    timeList.filter(time => this.fifteenIntervals.includes(time.format('mm')))
  )

  roundToFifteen = (time) => {
    const timeMoment = moment(time, 'H:mm')
    const distanceFromFifteen = timeMoment.minute() % 15
    return timeMoment.subtract(distanceFromFifteen, 'minutes').format('H:mm')
  }

  toggleManualTimes = (e, value) => {
    this.setState({
      manualTimes: value
    })
    if (value === false) {
      this.props.handleValueUpdate('start', this.roundToFifteen(this.props.start))
      this.props.handleValueUpdate('end', this.roundToFifteen(this.props.end))
    }
  }

  buildStartTimes = (earliestTime, latestTime) => {
    const times = [earliestTime]
    let lastTime = earliestTime.clone()
    while (lastTime < latestTime) {
      lastTime = lastTime.clone().add(1, 'minutes')
      times.push(lastTime)
    }
    return times
  }

  renderStartTimes = () => {
    const startTime = this.props.selectedBooking.start.clone()
    const earliestTime = startTime
      .clone()
      .hours('7')
      .minutes('00')

    const latestTime = startTime
      .clone()
      .hours('19')
      .minutes('45')

    const times = this.buildStartTimes(earliestTime, latestTime)
    this.setState({ startTimes: times })
  }

  buildEndTimes = (earliestTime, latestTime) => {
    const times = []
    let lastTime = earliestTime.clone().add(1, 'minutes')
    while (lastTime <= latestTime) {
      times.push(lastTime)
      lastTime = lastTime.clone().add(1, 'minutes')
    }
    return times
  }

  renderEndTimes = () => {
    const { selectedBooking: { start },
      start: startTimeString,
      end: endTimeString,
      handleValueUpdate,
    } = this.props
    const [startHour, startMinute] = startTimeString.split(':')
    const [endHour, endMinute] = endTimeString.split(':')
    const currentStartTime = start
      .clone()
      .hours(startHour)
      .minute(startMinute)

    const currentEndTime = currentStartTime
      .clone()
      .hours(endHour)
      .minute(endMinute)

    const latestEndTime = currentStartTime
      .clone()
      .hours('20')
      .minutes('45')

    const endTimes = this.buildEndTimes(currentStartTime, latestEndTime)
    if (currentStartTime >= currentEndTime) {
      handleValueUpdate('end', currentStartTime.add(15, 'minutes').format('H:mm'))
    }
    this.setState({ endTimes: endTimes })
  }

  renderDialog = (handleDeleteAll, handleDeleteOne, closeDialog) => {
    const options = [
      <FlatButton
        label="Delete All"
        primary={true}
        onClick={handleDeleteAll}
      />,
      <FlatButton
        label="Delete One"
        secondary={true}
        onClick={handleDeleteOne}
      />,
    ]
    return (
      <Dialog open={this.props.dialogOpen} actions={options} onRequestClose={closeDialog}>
        Delete all bookings in this series or just this one?
      </Dialog>
    )
  }

  selectOnChange = (updateValue) => (e, key, value) => {
    this.props.handleValueUpdate(updateValue, value)
  }

  autoCompleteOnChange = (updateValue, value) => {
    this.props.handleValueUpdate(updateValue, value)
  }

  render() {
    const {
      chairs,
      chairSelectItems,
      closeDialog,
      dayOfWeek,
      dialogOpen,
      doctor,
      doctors,
      edited,
      end,
      handleCreate,
      handleDeleteAll,
      handleDeleteOne,
      handleValueUpdate,
      isNew,
      location,
      locations,
      onClose,
      onDeleteClick,
      onSaveClick,
      recurring,
      renderDoctorOptions,
      renderLocationOptions,
      selectedBooking,
      start,
    } = this.props
    const {
      startTimes,
      endTimes,
    } = this.state

    return (
      <div className={styles.popover}>
        {dialogOpen &&
          this.renderDialog(handleDeleteAll, handleDeleteOne, closeDialog)}
        {selectedBooking.start.format('MMMM D, YYYY')}
        <div className={styles.actionsRow}>
          <Checkbox
            className={styles.manualTimeCheckbox}
            label='Manual Time Entry'
            checked={this.state.manualTimes}
            style={manualTimeCheckboxStyles}
            onCheck={(e, value) => {
              this.toggleManualTimes(e, value)
            }}
          />
        </div>
        <div className={styles.actionsRow}>
          {this.state.manualTimes ? (
            <ManualTimeFields
              start={start}
              end={end}
              autoCompleteOnChange={this.autoCompleteOnChange}
              startTimes={startTimes}
              endTimes={endTimes}
              className={styles.manualTimeFields}
            />
          ) : (
              <FifteenTimeFields
                start={start}
                end={end}
                selectOnChange={this.selectOnChange}
                startTimes={this.filterTimesFifteen(startTimes)}
                endTimes={this.filterTimesFifteen(endTimes)}
                className={styles.fifteenTimeFields}
              />
            )
          }
          <BookingDropdown value={chairs} labelText="chairs" onChange={this.selectOnChange}>
            {chairSelectItems}
          </BookingDropdown>
        </div>
        <div className={styles.actionsRow}>
          <BookingDropdown value={doctor || doctors[0].id} labelText="doctor" onChange={this.selectOnChange}>
            {renderDoctorOptions()}
          </BookingDropdown>
          <BookingDropdown value={location || locations[0].id} labelText="location" onChange={this.selectOnChange}>
            {renderLocationOptions()}
          </BookingDropdown>
        </div>
        {isNew ? (
          <div className={styles.buttonsContainer}>
            <Checkbox
              label={`Every ${dayOfWeek}`}
              className={styles.checkbox}
              checked={recurring}
              onCheck={(e, value) => {
                handleValueUpdate('recurring', value)
              }}
            />
            <FlatButton label="Discard" onClick={onClose} />
            <FlatButton label="Create" primary onClick={handleCreate} />
          </div>
        ) : (
            <div>
              <div className={styles.note}>
                <b>Note:</b>
                {recurring &&
                  edited && (
                    <p>
                      Edits will apply to this booking only, not all bookings in
                      the series.
                    </p>
                  )}
                <p>Appointments that were already booked will not be updated.</p>
              </div>
              <div className={styles.buttonsContainer}>
                <FlatButton
                  label="Delete"
                  secondary
                  className={styles.deleteButton}
                  onClick={onDeleteClick}
                />
                <FlatButton label="Discard" onClick={onClose} />
                <FlatButton
                  label="Save"
                  primary
                  onClick={onSaveClick}
                  disabled={!edited || resolvedAutoBooking(selectedBooking)}
                />
              </div>
            </div>
          )}
      </div>
    )
  }
}

RegularBookingPopover.propTypes = {
  chairs: PropTypes.number.isRequired,
  chairSelectItems: PropTypes.arrayOf(PropTypes.object),
  closeDialog: PropTypes.func.isRequired,
  dayOfWeek: PropTypes.string.isRequired,
  dialogOpen: PropTypes.bool,
  doctor: PropTypes.string,
  doctors: PropTypes.arrayOf(PropTypes.object),
  edited: PropTypes.bool,
  end: PropTypes.string.isRequired,
  handleCreate: PropTypes.func.isRequired,
  handleDeleteAll: PropTypes.func.isRequired,
  handleDeleteOne: PropTypes.func.isRequired,
  handleValueUpdate: PropTypes.func.isRequired,
  isNew: PropTypes.bool,
  location: PropTypes.string,
  locations: PropTypes.arrayOf(PropTypes.object),
  onClose: PropTypes.func.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
  onSaveClick: PropTypes.func.isRequired,
  recurring: PropTypes.bool,
  renderDoctorOptions: PropTypes.func.isRequired,
  renderLocationOptions: PropTypes.func.isRequired,
  selectedBooking: PropTypes.object.isRequired,
  start: PropTypes.string,
}

export default RegularBookingPopover



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/BookingsCalendar/BookingPopover/RegularBookingPopover.js